import React from 'react';
import { Modal } from 'react-bootstrap';
import { setModal } from './../../../../redux/actions/settings_app/setting_app.actions';
import { connect } from 'react-redux';
import TermConditionEditGlobal from './../../SalesInvoice/PaymentTerms/TermCondition.edit.global';

function SettingAppPaymentTermsEditModal({ edit_modal , setModal}) {
    return (
        <Modal centered dialogClassName="modal-container"  show={edit_modal} onHide={() => setModal('edit_modal', false)} size="md" animation={true}>
            <Modal.Header closeButton dialogClassName="p-0">
                <Modal.Title>Edit Payment Terms</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TermConditionEditGlobal pageOrigin="setting_app"/>
            </Modal.Body>
        </Modal>
    )
}


const mapStateToProps = state => ({
    edit_modal: state.setting_app.edit_modal
});

export default connect(mapStateToProps, { setModal })(SettingAppPaymentTermsEditModal);

